import dayjs from 'dayjs';
import { ChartTableData } from '../../pdf/reportPdfData';

/**
 * Labels for the header row of a chart table (see ChartTableData): bucket
 * timestamps and day indexes become dates in the report timezone, hour
 * indexes stay as they are.
 */
export function formatChartTables(
  table: ChartTableData,
  startAt: number,
  timezone: number
): any[][][] {
  const formatHeader = (header: any[]) => {
    if (table.headerKind === 'bucket') {
      return header.map((timestamp) =>
        dayjs(timestamp * 1000)
          .utcOffset(timezone * 60)
          .format(table.headerInterval === 'month' ? 'MMM YYYY' : 'DD MMM')
      );
    }

    if (table.headerKind === 'day') {
      return header.map((i) =>
        dayjs((startAt ?? 0) * 1000)
          .utcOffset(timezone * 60)
          .add(i, 'day')
          .format('DD MMM')
      );
    }

    return header;
  };

  return table.tables.map((rows) =>
    rows.map((row, rowIdx) => (rowIdx === 0 ? formatHeader(row) : row))
  );
}
